<template>
  <tci-recruit subtitle=".NET DEVELOPMENT ENGINEER" :title="$t('recruit.mainPage.recruit_dev')" :recruits="infos"></tci-recruit>
</template>

<script>
import TciRecruit from "@/components/TciRecruit.vue";

export default {
  name: "RecruitDeveloper",
  components: {
    "tci-recruit": TciRecruit
  },
  data: () => ({
    infos: [{"name":".NET开发工程师", "position":"苏州","email":"suzhou@trans-cosmos.com.cn","requests":[
      "专科以上学历，具有1~3 年 的C#开发实际经验；熟悉C/S和B/S结构。",
      "精通.Net Framework；熟练使用MVC、WebService 了解Java，Python，Android Studio等开发语言优先。",
      "熟练掌握JavaScript，熟悉CSS，了解HTTP协议。",
      "熟悉Sql server、Oracle、Mysql等主流数据库。",
      "对技术有较强的自我学习和提升能力、能快速融合企业团队文化，并有一定的抗压能力。"
    ],"responses":[
      "参与项目系统的需求沟通、设计与研发。",
      "按照设计要求和源代码编写规范编写程序代码，对其质量、性能负责。",
      "编写相关技术文档，负责进行开发阶段的软件测试。",
      "产品上线后，保障业务系统的稳定，解决相关技术问题。",
      "辅助项目经理，承担进度管理，品质管理，团队管理等管理工作。"
    ]}
    ]
  })
};
</script>
